import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { settingsConfig } from 'components/Settings/settingsConfig';
import { CustomerProfile } from 'components/widgets/CustomerProfile/CustomerProfile';

export const CustomerProfilePage = () => {
    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.customerProfile.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <CustomerProfile />
            </MainContent>
        </PageContainer>
    );
};
